import { replacePathParams } from '@/api/utils';

export const quoteApiPaths = {
  routeQuoteById: '/quoteservice/quotes/:quoteId',
  routeQuoteByIdCustomer: '/quoteservice/quotes/:routeQuoteId/customer',
  invoiceQuoteById: '/quoteservice/invoices/case/:caseId/document/:documentId',
  //
  generateQuote: '/caseservice/cases/:caseId/quote/generate',
  quoteRejectInternally: '/caseservice/cases/:caseId/quote/rejectinternally',
  quoteApproveInternally: '/caseservice/cases/:caseId/quote/approveinternally',
  quoteRejectByTXCenter: '/caseservice/cases/:caseId/quote/rejectbytxcenter',
  quoteApproveByTXCenter: '/caseservice/cases/:caseId/quote/approvebytxcenter',
  quoteSendToTXCenter: '/caseservice/cases/:caseId/quote/sendtotxcenter',
  quoteRecall: '/caseservice/cases/:caseId/quote/recall',
  quoteComment: '/caseservice/cases/:caseId/quote/comment',
  quoteApproveTxCenterProvider: '/caseservice/cases/:caseId/quote/approve-txcenter-provider',
  quoteTotals: '/quoteservice/quotes/totals',
} as const;

export const getQuoteApiUrl = {
  routeQuoteById: (quoteId: string) => replacePathParams(quoteApiPaths.routeQuoteById, { quoteId }),
  routeQuoteByIdCustomer: (routeQuoteId: string) =>
    replacePathParams(quoteApiPaths.routeQuoteByIdCustomer, { routeQuoteId }),
  invoiceQuoteById: (caseId: string, documentId: string) =>
    replacePathParams(quoteApiPaths.invoiceQuoteById, { caseId, documentId }),
  generateQuote: (caseId: string) => replacePathParams(quoteApiPaths.generateQuote, { caseId }),
  quoteRejectInternally: (caseId: string) => replacePathParams(quoteApiPaths.quoteRejectInternally, { caseId }),
  quoteApproveInternally: (caseId: string) => replacePathParams(quoteApiPaths.quoteApproveInternally, { caseId }),
  quoteRejectByTXCenter: (caseId: string) => replacePathParams(quoteApiPaths.quoteRejectByTXCenter, { caseId }),
  quoteApproveByTXCenter: (caseId: string) => replacePathParams(quoteApiPaths.quoteApproveByTXCenter, { caseId }),
  quoteSendToTXCenter: (caseId: string) => replacePathParams(quoteApiPaths.quoteSendToTXCenter, { caseId }),
  quoteRecall: (caseId: string) => replacePathParams(quoteApiPaths.quoteRecall, { caseId }),
  quoteApproveTxCenterProvider: (caseId: string) =>
    replacePathParams(quoteApiPaths.quoteApproveTxCenterProvider, { caseId }),
  quoteComment: (caseId: string) => replacePathParams(quoteApiPaths.quoteComment, { caseId }),
  quoteTotals: () => quoteApiPaths.quoteTotals,
};
